// AppHomeRedirect.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Adjust based on your auth hook

export default function AppHomeRedirect() {
  const location = useLocation();
  const { currentUser, guestConfig } = useAuth(); // Assuming currentUser is null when not logged in
  if (!currentUser && guestConfig === null) return <p>Loading workspace…</p>;
  return <Navigate to={`${currentUser || guestConfig?.enabled ? '/dashboard' : '/signup'}${location.search}${location.hash}`} replace />;
}
